export const ORG_SEARCH_MIN_LENGTH = 2
export const ORG_SEARCH_MAX_LENGTH = 200
export const ORG_SEARCH_CATEGORIES = [
	{ value: 'checkins', label: 'Check-ins' },
	{ value: 'experiences', label: 'Experiences' },
	{ value: 'users', label: 'Users' },
]

export const orgSearchParams = (query, type = 'all', page = 1) => {
	const params = new URLSearchParams({ q: query.trim() })
	if (type !== 'all') params.set('type', type)
	if (page > 1) params.set('page', String(page))
	return params
}

export const orgSearchPath = (orgSlug, query, type = 'all', page = 1) =>
	`/${encodeURIComponent(orgSlug)}/search?${orgSearchParams(query, type, page)}`

export const orgSearchResultPath = (orgSlug, item) => {
	const org = encodeURIComponent(orgSlug)
	if (item.type === 'checkins') {
		return `/${org}/experiences/${encodeURIComponent(item.experienceSlug)}/checkIn/${encodeURIComponent(item.id)}`
	}
	if (item.type === 'experiences') return `/${org}/experiences/${encodeURIComponent(item.experienceSlug)}/overview`
	if (item.type === 'users') {
		return item.isActive === false
			? `/${org}/admin/users?user=${encodeURIComponent(item.id)}`
			: `/${org}/admin/users/${encodeURIComponent(item.id)}/edit`
	}
	return `/${org}/search`
}
